(function () {
  if (window.__reelSoundToggleLoaded) return;
  window.__reelSoundToggleLoaded = true;

  function setCardMuted(card, muted) {
    var video = card.querySelector('video');
    var toggle = card.querySelector('[data-reel-sound-toggle]');
    if (video) video.muted = muted;
    if (toggle) {
      toggle.classList.toggle('is-muted', muted);
      toggle.setAttribute('aria-pressed', String(!muted));
      toggle.setAttribute('aria-label', muted ? 'Unmute' : 'Mute');
    }
  }

  // Only one reel plays with sound at a time — unmuting one mutes every
  // other card, matching dyou.co's reel behavior.
  function muteAllExcept(exceptCard) {
    document.querySelectorAll('.reel-card').forEach(function (card) {
      if (card !== exceptCard) setCardMuted(card, true);
    });
  }

  function toggleCard(card) {
    var video = card.querySelector('video');
    if (!video) return;

    var nowMuted = !video.muted;
    setCardMuted(card, nowMuted);
    if (!nowMuted) muteAllExcept(card);
  }

  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-reel-sound-toggle]');
    if (toggle) {
      event.preventDefault();
      event.stopPropagation();
      var toggleCard_ = toggle.closest('.reel-card');
      if (toggleCard_) toggleCard(toggleCard_);
      return;
    }

    // Clicking anywhere else on the video area also toggles sound — same
    // click-to-unmute behavior as the dedicated button — but not when the
    // click lands on the corner product badge, which should keep
    // navigating to the product instead.
    var media = event.target.closest('.reel-card__media');
    if (!media || event.target.closest('.reel-card__corner-badge')) return;

    var mediaCard = media.closest('.reel-card');
    if (mediaCard) toggleCard(mediaCard);
  });
})();
